import { render, staticRenderFns } from "./changedetail.vue?vue&type=template&id=ac239bca&scoped=true"
import script from "./changedetail.vue?vue&type=script&lang=js"
export * from "./changedetail.vue?vue&type=script&lang=js"
import style0 from "./changedetail.vue?vue&type=style&index=0&id=ac239bca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac239bca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac239bca')) {
      api.createRecord('ac239bca', component.options)
    } else {
      api.reload('ac239bca', component.options)
    }
    module.hot.accept("./changedetail.vue?vue&type=template&id=ac239bca&scoped=true", function () {
      api.rerender('ac239bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/changedetail.vue"
export default component.exports